module.exports = __webpack_public_path__ + "static/media/gold-glitter.6b147d51.jpg";